import {
  IScheduleHandler,
  ScheduleContext,
  ScheduleEvaluationResult,
} from "../types/index";
import { Playlist, ScheduleType, PriorityLevel } from "../types";

/**
 * Always Schedule Handler
 *
 * Handles playlists with ScheduleType.Always (0)
 * These playlists are always active with no time restrictions.
 *
 * Use case: Default content, fallback playlists, always-on announcements
 */
export class AlwaysScheduleHandler implements IScheduleHandler {
  public readonly scheduleType = ScheduleType.Always;

  /**
   * Evaluate if playlist is active
   * Always returns true for Always schedule type
   */
  evaluate(
    playlist: Playlist,
    context: ScheduleContext
  ): ScheduleEvaluationResult {
    // Always schedule is always active
    return {
      isActive: true,
      effectivePriority: playlist.priority,
      reason: "Always active (no schedule restrictions)",
      nextEvaluationTime: undefined, // No need to re-evaluate
    };
  }

  /**
   * Get next state change time
   * Always returns null since state never changes
   */
  getNextStateChange(
    playlist: Playlist,
    context: ScheduleContext
  ): Date | null {
    // Always schedule never changes state
    return null;
  }

  /**
   * Validate playlist configuration
   * Always schedule has no configuration requirements
   */
  validateConfiguration(playlist: Playlist): string[] {
    const errors: string[] = [];

    // Verify schedule type matches
    if (playlist.scheduleType !== ScheduleType.Always) {
      errors.push(
        `Schedule type mismatch: expected ${ScheduleType.Always}, got ${playlist.scheduleType}`
      );
    }

    // No other validation needed for Always schedule
    return errors;
  }
}
